<template>
    <header>
        <section>
            <a href="/" class="logo">
                <img src="../../../static/images/logo/logo.svg" />
            </a>
            <div style="float: right;">
                <ul>
                    <li v-for="item in navLists" :key="item.toPage" @click="openPage(item.path, item.key)" :class="{'active': activeRoute === '/'+item.toPage}">
                        <span>{{ item.label }}</span>
                        <p v-if="item.children && item.children.length">
                            <span v-for="o in item.children" @click.stop="anchorTo(o.path, o.key)" :key="o.key">{{ o.label }}</span>
                        </p>
                    </li>
                </ul>
                <span><button class="en" @click="goToCN">中文</button></span>
            </div>
        </section>
    </header>
</template>
<script>
import routerLists from '@/router/routerLists';
export default {
    name: 'headPart',
    data() {
        return {
            navLists: [...routerLists],
        }
    },
    computed: {
        activeRoute() {
            return this.$route.path;
        }
    },
    methods: {
        anchorTo (path, key) {
            this.$router.push(path);
            this.$emit('anchorTo', key);
        },
        openPage(url, key) {
            if(key === 'joinus') {
                window.open('http://fotoable.hirede.com/CareerSite/CampusRecruit');
                return;
            }
            // else if(key === 'publish'){
            //     window.open('https://www.wjx.cn/vm/O5wXxtW.aspx#');
            //     return;
            // }
            this.$router.push(url);
        },
        goToCN() {
            window.open("https://betta-games.com/")
        }
    }
}
</script>
<style scoped lang="less">
header {
    position: absolute;
    height: 50px;
    color: #fff;
    font-size: 14px;
    width: 100%;
    left: 0;
    top: 0;
    min-width: 1200px;
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.4;
        z-index: 4;
    }
    .logo {
        float: left;
        img {
            height: 26px;
            margin-top: 12px;
        }
    }
    section {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 50%;
        left: 50%;
        z-index: 6;
        width: 1080px;
        line-height: 50px;
        transform: translate(-50%, -50%);
    }
    li {
        position: relative;
        cursor: pointer;
        display: inline-block;
        text-align: center;
        vertical-align: top;
        padding: 0 30px;
        transition: .3s;
        -webkit-transition: .3s;
        p {
            display: none;
            position: absolute;
            top: 50px;
            left: 0;
            font-size: 10px;
            line-height: 20px;
            padding-bottom: 10px;
            width: 100%;
            transition: .3s;
            -webkit-transition: .3s;
            span {
                cursor: pointer;
                display: block;
                line-height: 24px;
            }
        }
        &:hover p {
            display: block;
        }
        &:hover, &.active {
            p::before, &::before{
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: #000;
                opacity: 0.7;
                z-index: -1;
            }
        }
    }
    ul {
        display: inline-block;
    }
    .en {
        display: inline-block;
        font-size: 12px;
        width: 28px;
        line-height: 14px;
        box-sizing: border-box;
        border: 1px solid #fff;
        margin-left: 30px;
    }
    .en:hover{
        background-color: #626262;
        color: #fff;
        border: 1px solid #626262;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/parts/headPart.vue